module.exports = __webpack_public_path__ + "static/media/techno.497cb65f.png";